<template>
  <button
    class="heart-button btn btn-naked border-0"
    :class="{ animate }"
    @click.stop="toggleFavourite"
  >
    <HeartIcon
      :class="[
        heartClass,
        heartSize,
        isFavourited ? color : 'text-white',
        showShadow ? 'drop-shadow' : '',
      ]"
      :style="{ stroke: !showStroke || isFavourited ? 'currentColor' : 'gray' }"
    />

    <template v-if="animate">
      <HeartIcon
        v-for="i in 10"
        :key="i"
        class="shadow-hearts w-4 h-4 absolute left-0 top-0 pointer-events-none z-50"
        :class="[color]"
      />
    </template>
  </button>
</template>

<script>
import HeartIcon from '@/assets/svg/icons/heart.svg?inline'

export default {
  components: { HeartIcon },

  props: {
    favourited: { type: Boolean, default: false },
    showShadow: { type: Boolean, default: false },
    showStroke: { type: Boolean, default: true },
    color: { type: String, default: 'text-red-400' },
    heartClass: { type: String, default: '' },
    heartSize: { type: String, default: 'w-6 h-6' },
  },

  data: () => ({
    animate: false,
    timeout: null,
  }),

  computed: {
    isFavourited() {
      return this.favourited
    },
  },

  methods: {
    confetti() {
      this.reset()

      this.animate = true
      this.timeout = setTimeout(() => this.reset(), 1001)
    },

    reset() {
      this.animate = false

      clearTimeout(this.timeout)
    },

    toggleFavourite(e) {
      e.stopPropagation()
      if (!this.isFavourited) {
        this.confetti()
        this.$emit('addFavourite')
      } else {
        this.$emit('removeFavourite')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.drop-shadow {
  filter: drop-shadow(0 0.1rem 0.15rem rgba(0, 0, 0, 0.35));
}

.heart-button.animate .shadow-hearts {
  animation: pop 1s ease-out;
}

.shadow-hearts {
  opacity: 0;

  @for $i from 1 through 20 {
    &:nth-of-type(#{$i}) {
      transform: translate3d(random(50) + px, random(100) - 100 + px, 0)
        rotate(random(45) + deg)
        matrix(1, 0, 0, 1, 0, -20);
    }
  }
}

@keyframes pop {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
</style>
